<ion-header [translucent]="true" class="ninja">
  <ion-toolbar class="thin-toolbar" mode="ios">
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <section class="w-100 d-flex flex-column justify-content-center old-style">
    <div class="pb-4">
      <a href="https://{{appVariables.WHITELABEL_LINK}}">
        <img
          class="d-block mx-auto logo"
          src="assets/img/{{appVariables.WHITELABEL_LOGO}}"
          alt="{{appVariables.WHITELABEL_BRAND}}"
        />
      </a>
    </div>
    <div class="set-password-box d-flex justify-content-center">
      <form class="p-3" [formGroup]="form">
        <h2 class="mb-3 into text-center">Set you signup data</h2>

        <div class="form-group">
          <label class="control-label">Full name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="Enter name">
          <control-messages [control]="nameControl"></control-messages>
        </div>

        <div class="form-group">
          <label class="control-label">Username</label>
          <input type="text" class="form-control" formControlName="username" placeholder="Enter username">
          <control-messages [control]="usernameControl"></control-messages>
        </div>

        <div class="form-group">
          <label class="control-label">Password</label>
          <input type="password" class="form-control" formControlName="password" placeholder="Enter password">
          <control-messages [control]="passwordControl"></control-messages>
        </div>

        <div class="form-group">
          <label class="control-label">Confirm password</label>
          <input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm password">
          <span class="text-error" *ngIf="form.errors?.passwordNotMatch">Passwords should match</span>
          <control-messages [control]="confirmPasswordControl"></control-messages>
        </div>

        <div class="row">
          <div class="form-group col">
            <button
              class="btn btn-success w-100"
              (click)="signup()"
              [disabled]="!form.valid || inProgress"
            >Save</button>
          </div>

          <div class="form-group col">
            <button
              class="btn btn-danger w-100"
              (click)="cancel()"
              [disabled]="inProgress"
            >Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </section>

</ion-content>
